import { ENVS, ENV_NAME } from "./envs";

//export const apiUrl = process?.env?.REACT_APP_API_URL || "https://dev-api.konfhub.com";
export const apiBase = "attendee-app";
export const apiUrl = ENVS?.[ENV_NAME]?.VITE_API_URL || "https://dev-api.konfhub.com";
export const eventBase = "event";
export const publicBase = "public";
export const eventId = ENVS?.[ENV_NAME]?.VITE_EVENT_ID || "c04761fb-dff2-417d-9c65-31198faf925b";
export const xApiKey = ENVS?.[ENV_NAME]?.VITE_X_API_KEY || "c8e680f8-30c3-4bc4-8e91-1c3ba5fc2a77";
